var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0716 0H9.06713C8.99883 0 8.93455 0.0317461 8.89437 0.0838096L5.08946 5.05651L1.28454 0.0838096C1.24437 0.0317461 1.18008 0 1.11178 0H0.107312C0.0202589 0 -0.0306339 0.0939684 0.0202589 0.16127L4.74258 6.33397C4.91401 6.55746 5.2649 6.55746 5.43499 6.33397L10.1573 0.16127C10.2095 0.0939684 10.1587 0 10.0716 0Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.8106fc7e935641841ebac0ad1f8c5b34.svg";
export { ForwardRef as ReactComponent };